import { Component } from '@angular/core';

import { KeycloakService } from '../../services/keycloak.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'help-cmp',
  templateUrl: 'help.html',

  imports: [CommonModule],
})
export class HelpComponent {
  isFarmer: boolean;

  public constructor() {
    this.isFarmer = KeycloakService.isFarmerOnly();
  }
}
